import { render, staticRenderFns } from "./editPriceDialog.vue?vue&type=template&id=7681a22a"
import script from "./editPriceDialog.vue?vue&type=script&lang=js"
export * from "./editPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./editPriceDialog.vue?vue&type=style&index=0&id=7681a22a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports